module.exports = __webpack_public_path__ + "img/video.237858ab.svg";